"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

require("../styles/_branding-description.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getEditDescriptionModal(_ref) {
  var showEditDetailsModal = _ref.showEditDetailsModal,
      handleModalClose = _ref.handleModalClose,
      handleModalSave = _ref.handleModalSave,
      descriptionText = _ref.descriptionText,
      handleDescriptionInputChange = _ref.handleDescriptionInputChange;
  return /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
    key: "company-description-modal",
    visible: showEditDetailsModal,
    onClose: handleModalClose,
    title: "About Us",
    onSave: handleModalSave,
    saveDisabled: false
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
    className: "organisation-description",
    multiline: true,
    label: "Description",
    placeholder: "Enter a summary of your organisation and what it does",
    defaultValue: descriptionText || '',
    onChange: handleDescriptionInputChange
  }));
}

var BrandingDescription = /*#__PURE__*/function (_Component) {
  _inherits(BrandingDescription, _Component);

  var _super = _createSuper(BrandingDescription);

  function BrandingDescription() {
    var _this;

    _classCallCheck(this, BrandingDescription);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleUploadClick", function () {
      var hasManagePermission = _this.props.hasManagePermission;

      if (hasManagePermission && _this._filePickerRef) {
        _this._filePickerRef.openFileChooser();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setFilePickerRef", function (ref) {
      if (ref && !_this._filePickerRef) {
        _this._filePickerRef = ref;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderEditSummaryButton", function () {
      var _this$props = _this.props,
          handleClick = _this$props.handleClick,
          hasManagePermission = _this$props.hasManagePermission;

      if (!hasManagePermission) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        type: "SECONDARY",
        small: true,
        onClick: handleClick
      }, "Edit Summary");
    });

    return _this;
  }

  _createClass(BrandingDescription, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          name = _this$props2.name,
          containerSize = _this$props2.containerSize,
          descriptionText = _this$props2.descriptionText,
          showEditDetailsModal = _this$props2.showEditDetailsModal,
          handleModalClose = _this$props2.handleModalClose,
          handleModalSave = _this$props2.handleModalSave,
          imageUrl = _this$props2.imageUrl,
          handleDescriptionInputChange = _this$props2.handleDescriptionInputChange,
          handleUploadImage = _this$props2.handleUploadImage,
          hasManagePermission = _this$props2.hasManagePermission;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('branding-description', {
          'branding-description--medium': containerSize.width < _vars.NUMERIC_MEDIA_SIZES.medium
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "branding-description__content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "branding-description__content__image-container"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
        key: "selectable-item-image",
        placeholderText: name,
        imageUrl: imageUrl,
        width: "140px",
        height: "140px",
        backgroundSize: "cover",
        isEditableImage: hasManagePermission,
        onClick: this.handleUploadClick,
        placeholderTextSize: 50
      }), /*#__PURE__*/_react.default.createElement(_commonReact.Files, {
        onFilesChange: handleUploadImage,
        allowedTypes: ['image'],
        minFileSize: 1,
        handleRef: this.setFilePickerRef
      }), containerSize.width < _vars.NUMERIC_MEDIA_SIZES.medium && this.renderEditSummaryButton()), /*#__PURE__*/_react.default.createElement("div", {
        className: "branding-description__content__summary"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "branding-description__content__summary__title"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        prefixIcon: "organisation",
        heading3: true,
        noMargin: true
      }, "About ".concat(name)), containerSize.width >= _vars.NUMERIC_MEDIA_SIZES.medium && this.renderEditSummaryButton()), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        className: (0, _classnames.default)('branding-description__content__summary__text', {
          'branding-description__content__summary__text__empty': !descriptionText
        })
      }, descriptionText || 'A summary hasn\'t been added yet.'))), hasManagePermission ? getEditDescriptionModal({
        showEditDetailsModal: showEditDetailsModal,
        handleModalClose: handleModalClose,
        handleModalSave: handleModalSave,
        descriptionText: descriptionText,
        handleDescriptionInputChange: handleDescriptionInputChange
      }) : null);
    }
  }]);

  return BrandingDescription;
}(_react.Component);

_defineProperty(BrandingDescription, "defaultProps", {
  showEditDetailsModal: false,
  descriptionText: ''
});

var _default = BrandingDescription;
exports.default = _default;